import { v4 } from 'uuid';
import { z } from 'zod';
import { video23AudioDataSchema } from '../next/builder/handlers.video23/typings.video23.js';

const legacyFlashcardSideTransformerSchema = z.object({
  label: z.string().nullish().optional().default(null),
  text: z.string(),
  centerText: z.boolean().optional().default(false),
  scaleImage: z.boolean().optional().default(false),
  image: z.string().transform(transformUrlOrReference).nullish().default(null),
  audio: z.string().transform(transformUrlOrReference).nullish().default(null)
});
const currentFlashcardAudioSchema = z.union([z.object({
  type: z.string(),
  value: z.string()
}), video23AudioDataSchema]).nullish();
const currentFlashcardImageSchema = z.object({
  type: z.string(),
  value: z.string(),
  alt: z.string().nullish().default(null)
}).nullish();
const currentFlashcardSideSchema = z.object({
  label: z.string().nullish().default(null),
  text: z.string(),
  centerText: z.boolean().optional().default(false),
  scaleImage: z.boolean().optional().default(false),
  image: currentFlashcardImageSchema,
  audio: currentFlashcardAudioSchema
});
const flashcardCardSchema = z.object({
  id: z.string().default(() => v4()),
  question: z.union([legacyFlashcardSideTransformerSchema, currentFlashcardSideSchema]),
  answer: z.union([legacyFlashcardSideTransformerSchema, currentFlashcardSideSchema])
});
const legacyFlashcardDataTransformerSchema = z.object({
  labels: z.object({
    question: z.string(),
    answer: z.string()
  }).default({
    question: "",
    answer: ""
  }),
  sections: z.array(z.object({
    cards: z.array(flashcardCardSchema)
  })).min(1)
}).transform(data => ({
  labels: data.labels,
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  cards: data.sections[0].cards,
  languages: {
    primary: "Danish"
  }
}));
const currentFlashcardDataSchema = z.object({
  labels: z.object({
    question: z.string(),
    answer: z.string()
  }),
  cards: z.array(flashcardCardSchema).min(1),
  languages: z.object({
    primary: z.enum(["Danish", "English", "Spanish", "French", "German"]),
    secondary: z.enum(["Danish", "English", "Spanish", "French", "German"]).nullish().default(null)
  }).default({
    primary: "Danish",
    secondary: null
  })
});
const flashcardDataSchema = z.union([currentFlashcardDataSchema, legacyFlashcardDataTransformerSchema]);
function transformUrlOrReference(urlOrReference) {
  if (!urlOrReference) {
    return null;
  }
  if (urlOrReference.startsWith("https://")) {
    return {
      type: "url",
      value: urlOrReference
    };
  }
  return {
    type: "reference",
    value: urlOrReference
  };
}

export { flashcardDataSchema, transformUrlOrReference };
//# sourceMappingURL=flashcard.component-data.js.map
